import { Trans } from 'react-i18next';

import { IS_RN_WEBVIEW, SUPPORT_TICKET_URL } from 'constants/constants';
import { Alert } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import styles from './selfieVerificationFailed.module.scss';

const textSelfieVerificationFailed = 'Selfie Verification Failed';

const SelfieVerificationFailed = ({ className }: { className?: string }) => {
  return (
    <Box className={className}>
      <Box className={styles.selfieFailedMsgContainer}>
        <Alert height={80} width={80} color="var(--negative)" />
        <Box as="h2" className={styles.heading}>
          {textSelfieVerificationFailed}
        </Box>
      </Box>
      <Box>
        <Box className={styles.failedMessage}>
          <Trans ns="auth" i18nKey="twoFaFaceAuth.selfieVerificationFailedMessage">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,, jsx-a11y/anchor-has-content  */}
            <a
              href={SUPPORT_TICKET_URL}
              color="var(--brand-bg-primary)"
              className={styles.supportTicketLink}
              data-testid="selfie-failed-delta-support-ticket"
              target={IS_RN_WEBVIEW ? '_self' : '_blank'}
              rel="noreferrer"
            />
          </Trans>
        </Box>
      </Box>
    </Box>
  );
};

export { SelfieVerificationFailed };
